import Loadable from '../../components/loadable';

const WaiverQuestionnaire = Loadable({
  loader: () => import('../../pages/waivers/create_waivers/questionnaires/waiver_questionnaire'),
});

angular.module('gym').value('WaiverQuestionnaire', WaiverQuestionnaire);
